// extracted by mini-css-extract-plugin
export default {"pageLoaderContainer":"pageLoader_pageLoaderContainer__HW-2z"};